<template>
  <div class='home'>
    <WoTermCategoryList
      v-show='listView'
      @newWoTermCategory='onClickNewFromList'
      @editWoTermCategory='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <WoTermCategoryForm
      v-show='formView'
      :woTermCategory='woTermCategory'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import WoTermCategoryList from '@/components/wo-term-category/WoTermCategoryList.vue'
import WoTermCategoryForm from '@/components/wo-term-category/WoTermCategoryForm.vue'

export default {
  name: 'WoTermCategory',
  components: {
    WoTermCategoryList,
    WoTermCategoryForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      woTermCategory: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.woTermCategory = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.woTermCategory = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.woTermCategory = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {}
}
</script>
